import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory({ basename: import.meta.env.BASE_URL });

let activeUnblockFunctions = new Set();

export function registerNavigationBlocker(unblockFn) {
  activeUnblockFunctions.add(unblockFn);
  return () => activeUnblockFunctions.delete(unblockFn);
}

export function temporarilyDisableAllNavigationBlockers() {
  // Temporarily remove all navigation blockers
  const currentBlockers = Array.from(activeUnblockFunctions);
  currentBlockers.forEach((unblock) => {
    if (typeof unblock === 'function') {
      unblock();
    }
  });
  activeUnblockFunctions.clear();
  return currentBlockers;
}

export function forceReplace(path, state) {
  // Disable all navigation blockers temporarily
  temporarilyDisableAllNavigationBlockers();

  // Perform the navigation
  browserHistory.replace(path, state);
}

export default browserHistory;
